import React from 'react';

import {ErrorBoundary} from 'app/general/structures/ErrorBoundary';
import {FlexPanel} from 'app/general/structures/FlexPanel';
import {SPErrorPage} from 'app/general/structures/SPErrorPage';

import {NavSidebarContainer} from './NavSidebarContainer';
import {SPHeader} from './SPHeader';

interface Props {
  children: React.ReactNode;
  renderRegularLink?: boolean;
}

function BaseSPFrame({children, renderRegularLink = false}: Props) {
  const [isSidebarOpened, setSidebarOpened] = React.useState(false);
  const toggleSidebar = () => setSidebarOpened(!isSidebarOpened);

  return (
    <FlexPanel
      type="vertical"
      secondary={
        <ErrorBoundary name="sp-header">
          <SPHeader
            onToggleSidebar={toggleSidebar}
            sidebarOpened={isSidebarOpened}
            renderRegularLink={renderRegularLink}
          />
        </ErrorBoundary>
      }
      secondaryZindex="10"
    >
      <NavSidebarContainer onToggle={toggleSidebar} opened={isSidebarOpened}>
        <ErrorBoundary name="page" ErrorComponent={SPErrorPage}>
          {children}
        </ErrorBoundary>
      </NavSidebarContainer>
    </FlexPanel>
  );
}

export function SPFrameWithRegularLinks({children}: Props): JSX.Element {
  return <BaseSPFrame renderRegularLink={true}>{children}</BaseSPFrame>;
}

export function SPFrame({children}: Props): JSX.Element {
  return <BaseSPFrame>{children}</BaseSPFrame>;
}
